import SwipeAction from 'antd-mobile/lib/swipe-action';
export default SwipeAction;



// WEBPACK FOOTER //
// ./components/swipe-action/index.tsx